import React from 'react';

export const LoadingScreen = () => (
  <div className="fixed inset-0 z-[9999] bg-gray-50 flex items-center justify-center will-change-transform">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
  </div>
);

export default LoadingScreen;